module.exports = __webpack_public_path__ + "assets/img/97@3x.7832945a.png";